import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '热搜榜', to: '/ranking' },
  { label: '话题分类', to: '/#topics' },
  { label: '深度盘点', to: '/#featured' },
  { label: '关于我们', to: '/about' },
];

export default function SiteNavbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur border-b border-background-200'
      }`}
    >
      <nav className="w-full px-4 md:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" aria-label="黑料今日 首页">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center text-lg ${
              transparent ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-fire-fill" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-bold tracking-tight ${
                transparent ? 'text-background-50' : 'text-foreground-950'
              }`}
            >
              黑料今日
            </span>
            <span
              className={`text-[10px] tracking-[0.22em] ${
                transparent ? 'text-background-100/80' : 'text-foreground-500'
              }`}
            >
              今日热点 · 热搜盘点
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const active =
              item.to === '/'
                ? location.pathname === '/' && !location.hash
                : item.to.startsWith('/#')
                ? location.pathname === '/' && location.hash === item.to.slice(1)
                : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  transparent
                    ? active
                      ? 'text-background-50 bg-background-50/15'
                      : 'text-background-100/90 hover:text-background-50 hover:bg-background-50/10'
                    : active
                    ? 'text-primary-700 bg-primary-100'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <Link
            to="/ranking"
            className="ml-2 px-4 py-2 rounded-full text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors flex items-center gap-1.5"
          >
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            看今日热榜
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl ${
            transparent ? 'text-background-50' : 'text-foreground-900'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} aria-hidden="true"></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-3 py-3 rounded-md text-sm text-foreground-800 hover:bg-background-100 hover:text-foreground-950 transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/ranking"
              className="mt-2 px-4 py-3 rounded-md text-sm text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              看今日热榜
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}